import styles from './SobreNos.module.css';
import ParticlesBackground from '../../components/ParticlesBackground/ParticlesBackground';
import { motion } from 'framer-motion';
import { FaCode, FaDatabase, FaHashtag, FaPalette, FaLaptopCode, FaChartLine } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import PageSEO from '../../components/PageSEO/PageSEO';

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 26 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
});

const members = [
  { name: 'Ygor Dagostin Rodrigues',   roleKey: 'sobreNos.devPleno',  img: '/YGOR.png'   },
  { name: 'Ivanio José Steimbach Jr',  roleKey: 'sobreNos.devJunior', img: '/IVANIO.png' },
  { name: 'Kauan Trindade Gonçalves',  roleKey: 'sobreNos.devJunior', img: '/kauan.png'  },
  { name: 'Gustavo Kamer',             roleKey: 'sobreNos.designer',  img: '/DESIGNER.png'},
];

function SobreNos() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.slice(0, 2) || 'pt';

  const pillars = [
    {
      title: t('sobreNos.steinsoft'),
      text: t('sobreNos.steinsoftDesc'),
    },
    {
      title: t('sobreNos.expertise'),
      text: t('sobreNos.expertiseDesc'),
    },
    {
      title: t('sobreNos.compromisso'),
      text: t('sobreNos.compromissoDesc'),
    },
  ];

  const services = [
    { Icon: FaCode,      title: t('sobreNos.s1'), desc: t('sobreNos.s1Desc') },
    { Icon: FaLaptopCode, title: t('sobreNos.s2'), desc: t('sobreNos.s2Desc') },
    { Icon: FaChartLine,  title: t('sobreNos.s3'), desc: t('sobreNos.s3Desc') },
    { Icon: FaDatabase,   title: t('sobreNos.s4'), desc: t('sobreNos.s4Desc') },
    { Icon: FaHashtag,    title: t('sobreNos.s5'), desc: t('sobreNos.s5Desc') },
    { Icon: FaPalette,    title: t('sobreNos.s6'), desc: t('sobreNos.s6Desc') },
  ];

  return (
    <>
      <PageSEO
        title="Sobre Nós"
        description="Conheça a equipe da SteinSoft: empresa especializada em desenvolvimento de software, terceirização Delphi, consultoria de TI e soluções digitais sob medida."
        path="/SobreNos"
        lang={lang}
      />
      <div className={styles.particles}>
        <ParticlesBackground />
      </div>

      <div className={styles.page}>

        {/* ── Hero ── */}
        <section className={styles.hero}>
          <motion.span className={styles.eyebrow} {...reveal()}>
            {t('sobreNos.eyebrow')}
          </motion.span>
          <motion.h1 className={styles.heroTitle} {...reveal(0.1)}>
            {t('sobreNos.tituloBase')} <span className={styles.accent}>{t('sobreNos.tituloAcc')}</span>
          </motion.h1>
          <motion.p className={styles.heroSub} {...reveal(0.2)}>
            {t('sobreNos.subtitulo')}
          </motion.p>
        </section>

        {/* ── Pilares ── */}
        <section className={styles.section}>
          <div className={styles.pillars}>
            {pillars.map((p, i) => (
              <motion.div key={i} className={styles.pillar} {...reveal(i * 0.12)}>
                <h2 className={styles.pillarTitle}>{p.title}</h2>
                <p className={styles.pillarText}>{p.text}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* ── Serviços ── */}
        <section className={styles.section}>
          <motion.h2 className={styles.sectionTitle} {...reveal()}>
            {t('sobreNos.nossosServicos')}
          </motion.h2>
          <div className={styles.servicesGrid}>
            {services.map((s, i) => (
              <motion.div key={i} className={styles.serviceCard} {...reveal(i * 0.08)}>
                <div className={styles.serviceIcon}>
                  <s.Icon />
                </div>
                <h3 className={styles.serviceTitle}>{s.title}</h3>
                <p className={styles.serviceDesc}>{s.desc}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* ── Equipe ── */}
        <section className={styles.section}>
          <motion.h2 className={styles.sectionTitle} {...reveal()}>
            {t('sobreNos.nossaEquipe')}
          </motion.h2>

          <motion.div className={styles.ceoCard} {...reveal(0.1)}>
            <div className={styles.ceoAvatar}>
              <img src="/ARTHUR.png" alt="Arthur Steinbach" />
            </div>
            <div className={styles.ceoInfo}>
              <span className={styles.ceoLabel}>{t('sobreNos.fundadorCeo')}</span>
              <h3 className={styles.ceoName}>Arthur Steinbach</h3>
              <p className={styles.ceoRole}>{t('sobreNos.devSenior')}</p>
            </div>
          </motion.div>

          <div className={styles.membersGrid}>
            {members.map((m, i) => (
              <motion.div key={i} className={styles.memberCard} {...reveal(0.1 + i * 0.1)}>
                <div className={styles.memberAvatar}>
                  <img src={m.img} alt={m.name} />
                </div>
                <h3 className={styles.memberName}>{m.name}</h3>
                <p className={styles.memberRole}>{t(m.roleKey)}</p>
              </motion.div>
            ))}
          </div>
        </section>

      </div>
    </>
  );
}

export default SobreNos;
